/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import {
    useBlockProps,
    InspectorControls,
} from '@wordpress/block-editor';


/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';
import TieredPricingTable from "./blocks/table/TieredPricingTable";
import ColumnsPanel from "./panels/ColumnsPanel/ColumnsPanel";
import TieredPricingBlocks from "./blocks/blocks/TieredPricingBlocks";
import TieredPricingOptions from "./blocks/options/TieredPricingOptions";
import TieredPricingDropdown from "./blocks/dropdown/TieredPricingDropdown";
import MainOptionsPanel from "./panels/MainOptionsPanel/DisplayTypePanel";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit({attributes, className, setAttributes}) {

    const blocks = {
        table: <TieredPricingTable attributes={attributes}/>,
        blocks: <TieredPricingBlocks attributes={attributes}/>,
        options: <TieredPricingOptions attributes={attributes}/>,
        dropdown: <TieredPricingDropdown attributes={attributes}/>,
    }

    return (
        <div {...useBlockProps()}>

            <InspectorControls key="setting" className="tiered-pricing-table__block-settings">
                <MainOptionsPanel attributes={attributes} setAttributes={setAttributes}/>
                {attributes.displayType === 'table' &&
                    <ColumnsPanel attributes={attributes} setAttributes={setAttributes}/>
                }
            </InspectorControls>

            <h3 style={{marginBottom: ".5em"}}>{attributes.title}</h3>

            {blocks[attributes.displayType] ? blocks[attributes.displayType] : blocks['table']}
        </div>

    );
}
